export default __webpack_public_path__ + "static/media/Rectangle3.b2c217fa.jpg";